import * as React from 'react';
import Header from 'components/Layout/Header/Layout1';
import Content from 'components/Layout/Content/Layout1';
import { useMediaQuery } from '@mui/material';

export const ProviderLayout = React.createContext(null);

const LayoutAdmin = ({ children }) => {

    const Layout630 = useMediaQuery('(min-width:630px)');
    const Layout900 = useMediaQuery('(min-width:900px)');

    const [open, setOpen] = React.useState(false);


    const [IsMenuOpen, setIsMenuOpen] = React.useState(true)
    const [IsOverMouse, setIsOverMouse] = React.useState(false)
    const [arrMenuOpen, setarrMenuOpen] = React.useState([])

    React.useEffect(() => {
        if (IsMenuOpen && !Layout900) {
            setIsMenuOpen(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Layout900])


    const handleClickMenuOpen = React.useCallback((menuID: number) => {
        const selectedIndex = arrMenuOpen.indexOf(menuID);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(arrMenuOpen, menuID);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(arrMenuOpen.slice(1));
        } else if (selectedIndex === arrMenuOpen.length - 1) {
            newSelected = newSelected.concat(arrMenuOpen.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                arrMenuOpen.slice(0, selectedIndex),
                arrMenuOpen.slice(selectedIndex + 1),
            );
        }
        setarrMenuOpen(newSelected);
    }, [arrMenuOpen]);

    const objProvider = React.useMemo(() => (
        {
            IsMenuOpen,
            setIsMenuOpen,
            IsOverMouse,
            setIsOverMouse,
            arrMenuOpen,
            handleClickMenuOpen,
            isMouseOver: false,
            Layout630,
            Layout900,
            open,
            setOpen
        }
    ), [IsMenuOpen, IsOverMouse, Layout630, Layout900, arrMenuOpen, handleClickMenuOpen, open]);


    return (
        <React.Fragment>
            <ProviderLayout.Provider
                value={objProvider}
            >
                <Header />
                <Content children={children} />
            </ProviderLayout.Provider>
        </React.Fragment>
    )
};
export default LayoutAdmin;